'use client';

import { useScrollRestoration } from '@/hooks/useScrollRestoration';

/**
 * Component to handle scroll restoration when navigating between pages
 * Scrolls to top accounting for sticky header
 */
export function ScrollRestoration() {
  useScrollRestoration();
  return null;
}
